// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SchedulesCallInviteesPlaceholder__avatar-c5999d {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  height: 48px;
}

.SchedulesCallInviteesPlaceholder__avatarLine-b22c99 {
  margin-inline-start: 8px;
}`, "",{"version":3,"sources":["webpack://./../../packages/components/src/Placeholders/SchedulesCallInviteesPlaceholder/SchedulesCallInviteesPlaceholder.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;AACF;;AAEA;EACE,wBAAA;AACF","sourcesContent":[".avatar {\n  display: flex;\n  align-items: center;\n  margin-bottom: 12px;\n  height: 48px;\n}\n\n.avatarLine {\n  margin-inline-start: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"avatar": `SchedulesCallInviteesPlaceholder__avatar-c5999d`,
	"avatarLine": `SchedulesCallInviteesPlaceholder__avatarLine-b22c99`
};
module.exports = ___CSS_LOADER_EXPORT___;
